export enum Filters {
  MARKET_AREA = 'MARKET_AREA',
  REGION = 'ZONE',
  SOURCE = 'SOURCE',
  BASECASE = 'BASECASE',
  SUBTYPE = 'SUBTYPE',
  WEATHER_YEAR = 'WEATHER_YEAR',
}
